<template>
	<div>
		<div v-if="treatment.image && treatment.image.ImageCrops[5]">
			<v-img :src="treatment.image.ImageCrops[5].CropUrl" class="align-end">
				<v-chip class="primary--text" label style="background-color:white">
					<v-card-title class="caption" v-text="treatment.name"> </v-card-title>
				</v-chip>
			</v-img>
		</div>
	</div>
</template>

<script>
export default {
	name: 'treatment-card',
	props: {
		treatment: {}
	},
	data() {
		return {};
	},
	created() {}
};
</script>

<style scoped></style>
